import { render, staticRenderFns } from "./navCompare.vue?vue&type=template&id=004df002&scoped=true&"
import script from "./navCompare.vue?vue&type=script&lang=js&"
export * from "./navCompare.vue?vue&type=script&lang=js&"
import style0 from "./navCompare.vue?vue&type=style&index=0&id=004df002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004df002",
  null
  
)

export default component.exports